<div *ngIf="!showCart" class="filter-section">
  <div class="date-filters">
    <label>
      Start Date:
      <input type="date" [(ngModel)]="startDate" />
    </label>

    <label>
      End Date:
      <input type="date" [(ngModel)]="endDate" />
    </label>
  </div>

  <app-customer-search (customerSelected)="handleCustomerSelection($event)"></app-customer-search>

  <div class="filter-buttons">
    <button class="full-width" mat-raised-button color="primary" (click)="page = 1; fetchOrders()">Apply Filter</button>
  </div>
</div>

<mat-card class="order-list-card" *ngIf="!showCart && orders.length > 0">
  <h3 class="card-title">Orders</h3>
  <table class="order-table">
    <thead>
      <tr>
        <th>Customer</th>
        <th>Voucher</th>
        <th>Date</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let order of orders" (dblclick)="viewOrderDetails(order)" class="clickable-row">
        <td>{{ order.customer_name }}</td>
        <td>{{ order.name }}</td>
        <td>{{ order.dateOrder | date: 'short' }}</td>
        <td>{{ order.totalAmount | number: '1.2-2' }}</td>
      </tr>
    </tbody>
  </table>

  <div class="summary-row">
    <span class="net-label">Total Amount:</span>
    <span class="net-value">{{ totalAmount | number: '1.2-2' }}</span>
  </div>

  <div class="pagination-controls">
    <button mat-button (click)="prevPage()" [disabled]="page === 1">Previous</button>
    <span>Page {{ page }} of {{ totalPages }}</span>
    <button mat-button (click)="nextPage()" [disabled]="page === totalPages">Next</button>
  </div>
</mat-card>
<div *ngIf="showCart">

  <app-cart [selectedCustomer]="selectedCustomerFromList"
            [selectedProducts]="selectedProducts"
            [disableOrder]="true"
            [disableEdit]="true"
            [disableDelete]="true"
            [disableDraft]="true">
  </app-cart>

  <div class="close-details-button">
    <button mat-raised-button color="accent" class="full-width" (click)="showCart = false">
      Close Details
    </button>
  </div>
</div>
